import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Typography,
  Button,
  message,
  Divider,
  Table,
  Input,
  Tooltip,
  Form,
  Modal,
  Select,
  Space,
  Dropdown,
  Tag,
} from "antd";
import {
  EditOutlined,
  SearchOutlined,
  PlusOutlined,
  DeleteOutlined,
  SettingOutlined,
  CheckOutlined,
  StopOutlined,
  BellOutlined,
  MessageOutlined,
} from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate } from "react-router-dom";
import http from "../../../services/http";
const { Text } = Typography;

// TODOS
const options_todos = [
  { value: 0, label: "Personalizado" },
  { value: 1, label: "Todos" },
];

// STATUS
const options_status = [
  { value: 0, label: "Inativo" },
  { value: 1, label: "Ativo" },
];

export const CadNotificacoes = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modal, contextHolder] = Modal.useModal();

  // ID ALTERAÇÃO
  const [idAlt, setIdAlt] = useState(0);
  const [search, setSearch] = useState("");

  useEffect(() => {
    listarNotificacoes();
  }, []);

  // LISTAR
  const listarNotificacoes = async () => {
    setLoading(true);
    const api = await http("get", `v1/notificacoes/listar`, []);
    if (api.statusCode === 200) {
      setDados(api.response.data);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CADASTRAR
  const cadastrarNotificacao = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/notificacoes/adicionar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registro cadastrado com sucesso!");
      setShowModal(false);
      resetForm();
      listarNotificacoes();
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // ALTERAR
  const alterarNotificacao = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/notificacoes/alterar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registro alterado com sucesso!");
      setShowModal(false);
      resetForm();
      listarNotificacoes();
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CARREGAR
  const carregarNotificacao = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/notificacoes/carregar/${id}`, []);

    if (api.statusCode === 200) {
      setShowModal(true);
      resetForm();
      form.setFieldsValue({
        descricao: api.response.data.descricao,
        todos_filiais: api.response.data.todos_filiais,
        todos_setores: api.response.data.todos_setores,
        todos_cargos: api.response.data.todos_cargos,
        obs: api.response.data.obs,
        status: api.response.data.status,
      });
      setIdAlt(api.response.data.id);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // DELETAR
  const deletarNotificacao = async (id) => {
    setLoading(true);
    const api = await http("post", `v1/notificacoes/deletar`, { id: id });
    if (api.statusCode === 200) {
      message.success("Registro deletado com sucesso!");
      listarNotificacoes();
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // GERAR
  const gerarNotificacoes = async (id) => {
    setLoading(true);
    const api = await http("post", `v1/notificacoes/gerar`, { id: id });
    if (api.statusCode === 200) {
      message.success("Notificações geradas com sucesso!");
      listarNotificacoes();
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // RESET FORM
  const resetForm = () => {
    form.resetFields();
    setIdAlt(0);
  };

  // COLUNAS TABLE
  const columns = [
    {
      title: "Descrição",
      dataIndex: "descricao",
      sorter: (a, b) => a.descricao?.localeCompare(b.descricao),
    },
    {
      key: "filiais",
      title: "Filiais",
      render: (_, e) => (e.todos_filiais === 1 ? "Todas" : "Personalizado"),
      sorter: (a, b) =>
        (a.status === 1 ? "Todas" : "Personalizado")?.localeCompare(b.status === 1 ? "Todas" : "Personalizado"),
    },
    {
      key: "setores",
      title: "Setores",
      render: (_, e) => (e.todos_setores === 1 ? "Todos" : "Personalizado"),
      sorter: (a, b) =>
        (a.status === 1 ? "Todos" : "Personalizado")?.localeCompare(b.status === 1 ? "Todos" : "Personalizado"),
    },
    {
      key: "cargos",
      title: "Cargos",
      render: (_, e) => (e.todos_cargos === 1 ? "Todos" : "Personalizado"),
      sorter: (a, b) =>
        (a.status === 1 ? "Todos" : "Personalizado")?.localeCompare(b.status === 1 ? "Todos" : "Personalizado"),
    },
    {
      key: "afetados",
      title: "Afetados",
      render: (_, e) => (e.afetados > 0 ? <Tag color="green">{e.afetados}</Tag> : <Tag color="red">0</Tag>),
      sorter: (a, b) => a.afetados?.toString()?.localeCompare(b.afetados?.toString()),
    },
    {
      key: "status",
      title: "Status",
      render: (_, e) => (e.status === 1 ? <Tag color="green">Ativo</Tag> : <Tag color="red">Inativo</Tag>),
      sorter: (a, b) =>
        (a.status === 1 ? "Enviado" : "Ag. Envio")?.localeCompare(b.status === 1 ? "Enviado" : "Ag. Envio"),
    },
    {
      key: "status_envio",
      title: "Status Envio",
      render: (_, e) => (e.status_envio === 1 ? <Tag color="green">Enviado</Tag> : <Tag color="red">Ag. Envio</Tag>),
      sorter: (a, b) =>
        (a.status_envio === 1 ? "Enviado" : "Ag. Envio")?.localeCompare(b.status_envio === 1 ? "Enviado" : "Ag. Envio"),
    },
    {
      dataIndex: "acoes",
      title: "Ações",
      width: 150,
      render: (_, e) => {
        const items = [
          e.todos_cargos === 0 && {
            label: "Liberações Cargos",
            key: "1",
            icon: <CheckOutlined />,
            onClick: () => navigate(`/notificacoes/cargos/${e.id}`),
          },
          e.todos_setores === 0 && {
            label: "Liberações Setores",
            key: "2",
            icon: <CheckOutlined />,
            onClick: () => navigate(`/notificacoes/setores/${e.id}`),
          },
          e.todos_filiais === 0 && {
            label: "Liberações Filiais",
            key: "3",
            icon: <CheckOutlined />,
            onClick: () => navigate(`/notificacoes/filiais/${e.id}`),
          },
          {
            label: "Liberações Usuários",
            key: "4",
            icon: <CheckOutlined />,
            onClick: () => navigate(`/notificacoes/colaboradores/${e.id}`),
          },
          {
            label: "Bloqueios Usuários",
            key: "5",
            icon: <StopOutlined />,
            onClick: () => navigate(`/notificacoes/colaboradores-bloqueio/${e.id}`),
          },
        ].filter((i) => i !== false);

        return (
          <Space.Compact>
            <Dropdown menu={{ items }}>
              <Button loading={loading} icon={<SettingOutlined />} />
            </Dropdown>

            {e.status_envio === 0 && (
              <React.Fragment>
                <Tooltip title="Editar">
                  <Button loading={loading} onClick={() => carregarNotificacao(e.id)} icon={<EditOutlined />} />
                </Tooltip>
                <Tooltip title="Excluir">
                  <Button
                    loading={loading}
                    icon={<DeleteOutlined />}
                    onClick={() => {
                      modal.confirm({
                        title: "Deseja deletar este registro?",
                        okText: "Sim",
                        cancelText: "Cancelar",
                        onOk() {
                          deletarNotificacao(e.id);
                        },
                      });
                    }}
                  />
                </Tooltip>

                {e.status === 1 && (
                  <Tooltip title="Gerar">
                    <Button
                      loading={loading}
                      icon={<MessageOutlined />}
                      onClick={() => {
                        modal.confirm({
                          title: "Deseja gerar as notificações?",
                          okText: "Sim",
                          cancelText: "Cancelar",
                          onOk() {
                            gerarNotificacoes(e.id);
                          },
                        });
                      }}
                    />
                  </Tooltip>
                )}
              </React.Fragment>
            )}
          </Space.Compact>
        );
      },
    },
  ];

  // SUBMIT FORM
  const onSubmit = (formulario) => {
    if (idAlt > 0) {
      formulario.id = idAlt;
      alterarNotificacao(formulario);
    } else {
      cadastrarNotificacao(formulario);
    }
  };

  // PESQUISAR
  const handleFilter = (pesquisar) => {
    let filteredData = dados?.filter(
      (val) =>
        val.descricao?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        val.obs?.toLowerCase().includes(pesquisar.toLowerCase())
    );
    return filteredData;
  };

  const dadosFilter = dados?.length > 0 ? handleFilter(search) : [];

  // FORMULÁRIO
  const modalFormulario = () => {
    return (
      <Modal
        title={
          <Text style={{ fontSize: 20 }}>
            <EditOutlined /> {idAlt > 0 ? "Editar" : "Adicionar"} Notificação
          </Text>
        }
        open={showModal}
        onOk={() => form.submit()}
        okText="Salvar"
        width={1200}
        okButtonProps={{ size: "large", loading: loading }}
        cancelButtonProps={{ size: "large", loading: loading }}
        onCancel={() => {
          setShowModal(false);
          resetForm();
        }}>
        <Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="descricao"
                label="Descrição"
                rules={[{ required: true, message: "Digite a descrição!" }]}>
                <Input size="large" disabled={loading} placeholder="Informe a descrição" />
              </Form.Item>
            </Col>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="todos_filiais"
                label="Filiais"
                rules={[{ required: true, message: "Selecione uma opção!" }]}>
                <Select
                  size="large"
                  placeholder="Selecione uma opção"
                  disabled={loading}
                  style={{ width: "100%" }}
                  options={options_todos}
                />
              </Form.Item>
            </Col>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="todos_setores"
                label="Setores"
                rules={[{ required: true, message: "Selecione uma opção!" }]}>
                <Select
                  size="large"
                  placeholder="Selecione uma opção"
                  disabled={loading}
                  style={{ width: "100%" }}
                  options={options_todos}
                />
              </Form.Item>
            </Col>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="todos_cargos"
                label="Cargos"
                rules={[{ required: true, message: "Selecione uma opção!" }]}>
                <Select
                  size="large"
                  placeholder="Selecione uma opção"
                  disabled={loading}
                  style={{ width: "100%" }}
                  options={options_todos}
                />
              </Form.Item>
            </Col>

            <Col className="gutter-row" span={24}>
              <Form.Item name="obs" label="Texto" rules={[{ required: true, message: "Informe o texto!" }]}>
                <Input.TextArea
                  size="large"
                  disabled={loading}
                  placeholder="Informe o texto"
                  rows={6}
                  autoSize={{ minRows: 5, maxRows: 7 }}
                />
              </Form.Item>
            </Col>

            <Col style={{ marginTop: "10px" }} className="gutter-row" span={24}>
              <Space direction="vertical" size={2}>
                <Text type="secondary">Menções:</Text>
                <Text type="secondary">
                  <ul>
                    <li>
                      Digite <Text strong>{"{{nome}}"}</Text> para referenciar o nome do colaborador.
                    </li>
                    <li>
                      Digite <Text strong>{"{{filial}}"}</Text> para referenciar a filial do colaborador.
                    </li>
                    <li>
                      Digite <Text strong>{"{{cpf}}"}</Text> para referenciar o CPF do colaborador.
                    </li>
                    <li>
                      Digite <Text strong>{"{{matricula}}"}</Text> para referenciar a matrícula do colaborador.
                    </li>
                  </ul>
                </Text>
              </Space>
            </Col>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="status" label="Status" rules={[{ required: true, message: "Selecione o status!" }]}>
                <Select
                  size="large"
                  placeholder="Selecione o status"
                  disabled={loading}
                  style={{ width: "100%" }}
                  options={options_status}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  };

  return (
    <Row align="middle" justify="center" className="content-row">
      {modalFormulario()}
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Configurações" onClickBack={() => navigate("/perfil")} />
            <HeaderTitle
              title="Gestão de Notificações"
              subtitle="Cadastro de notificações manuais"
              icon={<BellOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Space wrap>
                <Input
                  size="middle"
                  maxLength={100}
                  prefix={<SearchOutlined />}
                  className="input"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Pesquisar..."
                  allowClear
                />
                <Tooltip title="Adicionar Registro">
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => {
                      setShowModal(true);
                      resetForm();
                    }}
                    loading={loading}>
                    Novo
                  </Button>
                </Tooltip>
              </Space>

              <Divider />

              <Table
                loading={loading}
                rowKey="id"
                scroll={{ x: 700 }}
                columns={columns}
                dataSource={dadosFilter}
                size="small"
                expandable={{
                  expandedRowRender: (e) => e?.obs,
                }}
              />
            </Card>
          </div>
        </Col>
      </Col>
      {contextHolder}
    </Row>
  );
};
